import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { BasePage } from '../base.page';

@Component({
  selector: 'app-basic-information',
  templateUrl: './basic-information.component.html',
  styleUrls: ['./basic-information.component.scss']
})
export class BasicInformationComponent extends BasePage implements OnInit {

  constructor(protected route: ActivatedRoute, protected translate: TranslateService) {
    super(route, translate);
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/basic-information/basic-information.component.ts